import React from 'react'
import HeroSection from './HeroSection'

export default () => (
  <HeroSection
    left={
      <>
        <p className="topic">financial well-being</p>
        <h2>Build savings with each step</h2>
        <p className="description">
          Set aside $1 for every 1,000 steps you naturally take each day.{' '}
        </p>
      </>
    }
    right={
      <img
        className="screenshot-right"
        src="/images/app/app-screen-4@2x.png"
        alt="savings chart"
      />
    }
  />
)
